import { NonProfitService } from './services/NonProfitService';
import type { Init, NonProfitUrlAdapter } from './types';
import { managerHelpers } from '../../helpers';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import type { WidgetLifecycle } from '../WidgetLifecycle';
import { WithApi } from '../WithApi';

export type NonProfitData = MergedDataReturnType<[NonProfitService]>;

export type NonProfitHandlers = MergedHandlersReturnType<[NonProfitService]>;

type TApi = ReturnType<NonProfitService['api']>;

export class NonProfitManager extends WithApi<TApi> {
  constructor(private urlAdapter: NonProfitUrlAdapter) {
    super();
  }

  public nonProfitInit = ({ pageStore, queries, mutations, flags, t }: Init) => {
    const [paymentPlanQuery] = queries;

    const [updatePaymentPlanMutation] = mutations;

    const pending = paymentPlanQuery.isPending;

    const { error } = paymentPlanQuery;

    if (pending) {
      return {
        status: 'pending',
        data: null,
        handlers: null,
        lifecycle: {} as WidgetLifecycle,
      } as const;
    }

    if (error) {
      return {
        status: 'error',
        data: error,
        handlers: {
          retry: () => {
            managerHelpers.retryQueries(queries);
          },
        },
        lifecycle: {} as WidgetLifecycle,
      } as const;
    }

    const nonProfit = new NonProfitService(
      pageStore,
      paymentPlanQuery.data,
      updatePaymentPlanMutation,
      this.urlAdapter,
      flags,
      t
    );

    this.initApi({
      ...nonProfit.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...nonProfit.data(),
      },
      handlers: {
        ...nonProfit.handlers(),
      },
      lifecycle: {
        onMount() {
          nonProfit.onMount();
        },
      } as WidgetLifecycle,
    } as const;
  };
}
